<template>
  <div>
    <pageHeader />
    <router-view></router-view>
    
  </div>
</template>

<script>
/* import pageFooter from "@/components/pageFooter.vue"; */
import pageHeader from "@/components/pageHeader.vue";
/* import { Swiper, SwiperSlide } from 'swiper/vue'; */


export default {
  name: "App",
  components: {
    pageHeader,
    /* pageFooter, */
    
    
    /* Swiper,
    SwiperSlide, */
  },
  
  /* data() {
    return {
      swiperOptions: {
        // Swiper 옵션을 설정합니다.
        slidesPerView: 3,
        spaceBetween: 30,
        // 기타 옵션들...
      },
    };
  }, */
};
</script>
<style lang="scss">
@import "@/assets/scss/common.scss";
@import "@/assets/scss/font.scss";
@import "@/assets/scss/layout.scss";

/* @import 'swiper/swiper-bundle.css';  */
</style>
